import React from 'react';
import { Stack, Avatar, Chip, Typography } from '@mui/material';
import { Student } from '@/types';

interface StudentProfileProps {
  student: Student;
}

export const StudentProfile: React.FC<StudentProfileProps> = ({ student }) => {
  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Avatar
        src={student.photo}
        alt={`${student.firstName} ${student.lastName}`}
        sx={{
          width: 48,
          height: 48,
          border: '2px solid',
          borderColor: 'primary.light',
          boxShadow: 1
        }}
      />
      <Stack spacing={0.5}>
        <Typography 
          variant="h6" 
          sx={{ 
            fontSize: '1.1rem',
            fontWeight: 600,
            color: 'primary.main'
          }}
        >
          {student.firstName} {student.lastName}
        </Typography>
        <Stack direction="row" spacing={1} alignItems="center">
          <Chip
            label={`Grade ${student.grade}`}
            size="small"
            color="primary"
            variant="outlined"
          />
          <Typography variant="caption" color="text.secondary">
            ID: {student.id}
          </Typography>
          <Chip
            label={`${student.attendanceRate}% Attendance`}
            size="small"
            color={student.attendanceRate >= 90 ? 'success' : 'warning'}
            variant="outlined"
          />
        </Stack>
      </Stack>
    </Stack>
  );
};